// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7761) return "static/chunks/7761-bf4a53498b265b20.js";
	if (chunkId === 7737) return "static/chunks/7737-570e5003596a6b57.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6020 ? "8abc4a02" : chunkId) + "." + {"3056":"eb6caf17d950c394","6020":"27fff461e807f1bf"}[chunkId] + ".js";
};